import React, { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import axios from "axios";

import Api from "../Api/Api";
import { isAutheticated } from "./auth/authhelper";

import { ToastContainer } from "react-toastify";
import { toastSuccess, toastWarning } from "../utilis/toast";
import "react-toastify/dist/ReactToastify.css";

import Slider from "react-slick";
import { FiShare2 } from "react-icons/fi";
import { Helmet } from "react-helmet-async";

import { windowScrollUp } from "../utilis/window";
import { API, username } from "../API";
import { crewSettingsVideos } from "../Config/Slider";
import NavBar from "./Navbar";

const MovieView = () => {
  const { token } = isAutheticated();
  const history = useHistory();

  const [movie, setMovie] = useState(null);
  const [checkWatchlist, setCheckwatchlist] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [videoChannelName, setVideoChannelName] = useState("");
  const [videoCategoryLogo, setVideoCategoryLogo] = useState("");
  const [channelType, setChannelType] = useState("");
  const [channelID, setChannelID] = useState("");
  const [mainChannelName, setmainChannelName] = useState("");


  const [subscription, setSubscription] = useState(false);
  const [plan, setPlan] = useState({});

  const { slug } = useParams();
  const videoid = slug?.split("-").pop();
  useEffect(() => {
    if (channelType) console.log("channelType", channelType);
  }, [channelType]);

  /** Fetch movie info */
  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await Api.getMovieInfo(username, videoid);
        setMovie(data);
        console.log("video llllldetails", data)
        setChannelType(data?.channelType);
        setChannelID(data?.channel?._id);
        setmainChannelName(data?.channel?.parentChannel?.name)
        setVideoChannelName(data?.channel?.name);
        setVideoCategoryLogo(data?.channel?.logo?.url || "");
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching movie:", err);
        setIsLoading(false);
      }
    };
    getData();
  }, [videoid]);

  /** Fetch watchlist info */
  useEffect(() => {
    const getWatchlist = async () => {
      try {
        const { video } = await Api.getWatchList();
        setCheckwatchlist(video?.some((v) => v._id === videoid));
      } catch (err) {
        console.error("Error fetching watchlist:", err);
      }
    };
    getWatchlist();
  }, [videoid]);

  /** Subscription check */
  useEffect(() => {
    axios
      .get(`${API}/api/subscription/setting`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data } = response?.data;
        setSubscription(data?.subscriptionRequired);
        setPlan(data?.plans || {});
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.error ||
          err.message ||
          "An error occurred while fetching subscription settings";
        console.error(errorMessage);
      });
  }, [token]);

  /** Watchlist handlers */
  const addToWatchlistHandler = async () => {
    windowScrollUp();
    try {
      await axios.post(
        `${API}/api/watchlist/add_watchlist/${videoid}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCheckwatchlist(true);
      toastSuccess("Added to Watchlist");
    } catch {
      toastWarning("Already in Watchlist");
    }
  };

  const removeFromWatchlistHandler = async () => {
    windowScrollUp();
    try {
      await Api.RemoveFromWatchlist(videoid);
      setCheckwatchlist(false);
      toastSuccess("Removed from Watchlist");
    } catch (err) {
      console.error("Error removing from watchlist:", err);
    }
  };

  /** Share handler */
  const handleShare = async () => {
    // ✅ Use current full URL instead of a fixed /view/ path
    const currentUrl = window.location.href;

    const shareData = {
      title: movie?.title || "Check out this video!",
      text: `${movie?.title || ""}\n\n${movie?.description || ""}`,
      url: currentUrl, // ✅ share the full path
    };

    try {
      // Try sharing with poster image if supported
      if (navigator.canShare && movie?.banner) {
        const response = await fetch(movie.banner);
        const blob = await response.blob();
        const file = new File([blob], "poster.jpg", { type: blob.type });

        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ ...shareData, files: [file] });
          return;
        }
      }

      // Default Web Share API
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback: copy link to clipboard
        await navigator.clipboard.writeText(
          `${shareData.title}\n\n${shareData.text}\n${shareData.url}`
        );
        toastSuccess("Video link copied! Paste it to share.");
      }
    } catch (err) {
      console.error("Error sharing:", err);
      await navigator.clipboard.writeText(
        `${shareData.title}\n\n${shareData.text}\n${shareData.url}`
      );
      toastSuccess("Video link copied! Paste it to share.");
    }
  };


  // console.log("mainChannelName", mainChannelName)
  /** Channel navigation */
  // const slugify = (text = "") =>
  //   `${videoChannelName.replace(/\s+/g, "-")}/channel/${text
  //     .toLowerCase()
  //     .replace(/[^a-z0-9]+/g, "-")
  //     .replace(/^-|-$/g, "")}`;

  const slugify = (mainChannelName = "", text = "") => {
    const textSlug = text?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

    if (mainChannelName) {
      const mainSlug = mainChannelName?.toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
      return `${mainSlug}/channel/${textSlug}`;
    } else {
      return `net_channel/${textSlug}`;
    }
  };




  // let navigateUrl;
  // if (channelType === "Subchannels") {
  //   navigateUrl = slugify(mainChannelName, videoChannelName);
  // } else {
  //   const textSlug = videoChannelName?.toLowerCase()
  //     .replace(/[^a-z0-9]+/g, "-")
  //     .replace(/^-|-$/g, "");
  //   navigateUrl = `net_channel/${textSlug}`;
  // }
let navigateUrl;
  if (channelType === "SoComAdvisor") {
    // navigateUrl = slugify(`apex_channel/${movie?.channel?.advisor_Name_Slug}`);
    const advisorSlug = movie?.channel?.advisor_Name_Slug || null
    navigateUrl = `apex_channel/${advisorSlug}`;

  }
  else if (channelType === "Subchannels") {
    navigateUrl = slugify(mainChannelName, videoChannelName);
  } else {
    const textSlug = videoChannelName?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
    navigateUrl = `net_channel/${textSlug}`;
  }



  const Channelslug = (text = "") => {
    const textSlug = text?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
    return `${textSlug}`;
  }
  console.log("channelType", channelType)
  return (
    <>
      <Helmet>
        <title>{movie?.title || "SoComOTT Explore Product Videos"}</title>
        <meta
          name="description"
          content={`Discover ${movie?.title || "engaging product videos"} and more.`}
        />
        <meta
          name="keywords"
          content={`${movie?.title || "Video"}, Channel, Product`}
        />

        {/* OG for previews */}
        <meta property="og:title" content={movie?.title || "Watch Video"} />
        <meta
          property="og:description"
          content={movie?.description || "Watch engaging product videos now!"}
        />
        <meta
          property="og:image"
          content={movie?.banner || movie?.thumbnail || "/default-poster.jpg"}
        />
        <meta
          property="og:url"
          content={`${window.location.origin}/view/${slug}`}
        />
        <meta property="og:type" content="video.other" />

        {/* Twitter preview */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={movie?.title || "Watch Video"} />
        <meta
          name="twitter:description"
          content={movie?.description || "Watch engaging product videos now!"}
        />
        <meta
          name="twitter:image"
          content={movie?.banner || movie?.thumbnail || "/default-poster.jpg"}
        />
      </Helmet>


      <NavBar
        categoryLogo={videoCategoryLogo}
        // category={videoChannelName}
        categoryId={navigateUrl}
      />

      {!videoid || !username ? (
        <h2 className="movie-name">Not a valid video</h2>
      ) : isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
          <p className="text-light">Loading...</p>
        </div>
      ) : movie && movie.live ? (
        <div className="px-3 px-md-5">
          {/* Banner */}
          <div style={{ position: "relative", height: "90vh", overflow: "hidden" }}>
            <img
              src={movie.banner || movie.thumbnail}
              alt={movie.title || "Video Banner"}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />

            {/* Play button */}
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
            <Link
                to={{
                  // 1. Logic for the Pathname (URL string)
                  pathname: !subscription
                    ? (channelType === "Subchannels"
                      ? `/${Channelslug(mainChannelName)}/channel/${Channelslug(videoChannelName)}/${slug}/play`
                      : `/${Channelslug(videoChannelName)}/${slug}/play`)
                    : `/${username}/details/payment`,

                  // 2. Query Parameters (the ?v= part)
                  search: !subscription ? `?v=${encodeURIComponent(movie?.video || "")}` : "",

                  // 3. State Object (This sends the current URL to the next page)
                  state: { fromUrl: window.location.href }
                }}
                style={{ textDecoration: "none" }}
              >
                <img
                  src="/assets/images/icons/play-icon.png"
                  alt="Play Icon"
                  style={{
                    height: "150px",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                />
              </Link>
            </div>
          </div>

          {/* Details */}
          <div className="container mt-5 text-light">
            <div className="row align-items-center mb-4">
              <div className="col-12 col-md-9 mb-3">
                <h3 className="text-warning fw-bold">{movie?.title}</h3>
                <p className="text-muted fs-5">{movie?.description}</p>
              </div>

              <div className="col-12 col-md-3 d-flex flex-column flex-md-row align-items-center">
                <button
                  onClick={handleShare}
                  className="btn btn-warning mb-2 w-100 d-md-block"
                  style={{
                    borderRadius: "20px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    padding: "12px 20px",
                    maxWidth: "60%",
                  }}
                >
                  <FiShare2 size={16} className="me-1" /> Share
                </button>
              </div>
            </div>

            {/* Crew */}
            {movie.Actors_list?.length > 0 && (
              <div className="mt-5">
                <h4 className="fw-bold text-warning">Crew</h4>
                <Slider {...crewSettingsVideos} className="mt-4">
                  {movie.Actors_list.map((actor, index) => (
                    <div
                      key={index}
                      className="text-center bg-dark p-3 rounded shadow-sm"
                      style={{ maxWidth: "280px", margin: "0 auto" }}
                    >
                      <img
                        src={actor.image}
                        alt={actor.name}
                        className="rounded-circle mb-3 shadow"
                        style={{ height: "225px", width: "225px", maxWidth: "100%", objectFit: "cover" }}
                      />
                      <div>
                        <span className="text-warning fw-bold">{actor.name}</span>
                        <br />
                        <small className="text-muted">{actor.asCharacter}</small>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            )}

            <ToastContainer position="top-right" autoClose={2000} />
          </div>
        </div>
      ) : (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ height: "80vh", color: "#ff4c4c" }}
        >
          <img
            src="/assets/images/icons/error-video.png"
            alt="Video Unavailable"
            style={{ width: "180px", maxWidth: "100%", marginBottom: "20px" }}
          />
          <h3 className="fw-bold">This video is currently unavailable</h3>
          <p className="text-muted">
            The video may have been <strong>suspended</strong> or <strong>deleted</strong>.
          </p>
        </div>
      )}
    </>
  );
};

export default MovieView;
